import React from "react"
import {Navigate, matchPath, useLocation} from "react-router-dom"

export interface IndexRedirectProps {
  to: string
  match?: string | {url: string}
  permissions?: string | string[]
  title?: string
}

/**
 * Redirects an index route (exact match of the current path) to a
 * specified child path while preserving the current query string.
 *
 * Example:
 *   If the current matched URL is `/admin` and `to="/users"`, navigating to
 *   `/admin` will redirect to `/admin/users`.
 */
const IndexRedirect: React.FC<IndexRedirectProps> = ({match: matchProp, to}) => {
  const location = useLocation()
  let url = typeof matchProp === "object" ? matchProp.url : matchProp || "/"
  const query = location.search || ""

  const isMatch = matchPath({path: url, end: true}, location.pathname)
  if (!isMatch) return null

  /** remove doubled up `/`'s between `url` and `to` */
  if (url.charAt(url.length - 1) === "/" && to.charAt(0) === "/") {
    url = url.slice(0, -1)
  }

  return <Navigate replace to={{...location, pathname: `${url}${to}${query}`}} />
}

export default IndexRedirect
